import React, {useContext, useEffect, useState} from 'react'
import headbandContext from 'contexts/headband'
import "./capsuleAnfh.scss"
export default function CapsuleAnfh(props) {
    const {setCounter, counterDefault} = props
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Capsules ANFH",
            icon : "picto_capsule_anfh.svg",
            color : "bckGreen"
        })
        setCounter(250)
    }, [])
	const [src, setSrc] = useState(1)
	const [video, setVideo] = useState(1)
	const choix = (e) => {
        setCounter(250)
		// setVideo(false)
		setSrc(e)
		// setVideo(true)

	}
	return (
		<div id="capsuleAnfh" className='page'>
			<div id="videoTop">
				<video src={"/videos/" + src + ".mp4"} autoPlay width="1080"></video>
			</div>
            <ul>
                <li onClick={()=>choix(1)}>
                    <img className="bulle" src={src === 1 ? "/picto_lecteur_video_bleu_fonce_negatif.svg" : "/picto_lecteur_video_bleu_fonce.svg"} alt="picto"/>
                    <p><span>La formation professionnelle</span> et <span>le développement des compétences</span> dans la Fonction publique hospitalière</p>
                </li>
                <li onClick={()=>choix(2)}>
                    <img className="bulle" src={src === 2 ? "/picto_lecteur_video_bleu_fonce_negatif.svg" : "/picto_lecteur_video_bleu_fonce.svg"} alt="picto"/>
                    <p><span>La laïcité</span> dans la Fonction publique hospitalière</p>
                </li>
                <li onClick={()=>choix(3)}>
                    <img className="bulle" src={src === 3 ? "/picto_lecteur_video_bleu_fonce_negatif.svg" : "/picto_lecteur_video_bleu_fonce.svg"} alt="picto"/>
                    <p><span>L'usage des réseaux sociaux </span>chez les professionnels hospitaliers</p>
                </li>
                <li onClick={()=>choix(4)}>
                    <img className="bulle" src={src === 4 ? "/picto_lecteur_video_bleu_fonce_negatif.svg" : "/picto_lecteur_video_bleu_fonce.svg"} alt="picto"/>
                    <p><span>Les droits et les obligations</span> des agents de la Fonction publique hospitalières</p>
                </li>
                <li onClick={()=>choix(5)}>
                    <img className="bulle" src={src === 5 ? "/picto_lecteur_video_bleu_fonce_negatif.svg" : "/picto_lecteur_video_bleu_fonce.svg"} alt="picto"/>
                    <p><span>La discrètion </span>professionnelle et <span>le secret </span>professionnel</p>
                </li>
                <li onClick={()=>choix(6)}>
                    <img className="bulle" src={src === 6 ? "/picto_lecteur_video_bleu_fonce_negatif.svg" : "/picto_lecteur_video_bleu_fonce.svg"} alt="picto"/>
                    <p><span>Bien formuler</span> sa demande de formation</p>
                </li>
                <li onClick={()=>choix(7)}>
                    <img className="bulle" src={src === 7 ? "/picto_lecteur_video_bleu_fonce_negatif.svg" : "/picto_lecteur_video_bleu_fonce.svg"} alt="picto"/>
                    <p><span>Les éco-gestes</span></p>
                </li>
                <li onClick={()=>choix(8)}>
                    <img className="bulle" src={src === 8 ? "/picto_lecteur_video_bleu_fonce_negatif.svg" : "/picto_lecteur_video_bleu_fonce.svg"} alt="picto"/>
                    <p><span>Le Compte personnel de formation</span></p>
                </li>
			</ul>
            <div style={{width : "200px"}} className="centerImg">
                    <img src="/finger_blue.svg" alt="" />
            </div>
		</div>
    )
}
